<template>
  <div class="hero container">
    <img
      class="hero__logo"
      src="../../assets/crowdfunding/logo-mastercraft.svg"
      alt="logo - mastercraft"
    >
    <div class="hero__content">
      <h3 class="hero__title">
        mastercraft bamboo monitor riser
      </h3>
      <p class="hero__text">
        A beautiful & handcrafted monitor stand to reduce neck and eye strain.
      </p>
    </div>
    <div class="hero__cta">
      <Button value="Back to this project" />
      <div class="hero__bookmark">
        <img class="bookmark" src="../../assets/crowdfunding/icon-bookmark.svg" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import Button from './reusable/Button.vue';

export default {
  components: {
    Button,
  },
  props: {
    products: Array,
  },
};
</script>

<style lang="scss" scoped>
.hero {
  padding: calc(var(--sm-spacer) * 1.7)
            calc(var(--sm-spacer) / 2)
            calc(var(--sm-spacer));
  background-color: var(--white);
  border-radius: var(--border-radius);
  margin-top: -3.5rem;
  box-shadow: 0 0 1px 0 var(--dark-gray);
  position: relative;
  max-width: var(--text-width);

  &__title {
    font-size: var(--fs-h4);
    line-height: 1.2;
    text-transform: capitalize;
    margin-bottom: calc(var(--sm-spacer) / 2);
  }

  &__text {
    color: var(--dark-gray);
    margin-bottom: calc(var(--sm-spacer) / 1.5);
  }

  &__logo {
    position: absolute;
    bottom: calc(100% - 2rem);
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
  }

  &__cta {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;

  .hero__bookmark {
    cursor: pointer;

    img {
      height: 4rem;
      vertical-align: middle;
    }

    &:hover {
      opacity: 0.7;
    }

    .button {
      width: 70%;
    }

    @media (min-width: 60em) {
      .button {
        width: max-content;
      }
    }
  }
}
}
</style>
